import React from "react";
import logo from "../../assets/Logo/logo-new.svg";
import { Link, useNavigate } from "react-router-dom";
import MaContainer from "../../Components/Common/container";
import MaButton from "../../Components/UI/ma-button";
import { MdOutlineKeyboardBackspace } from "react-icons/md";

const Header = () => {
  const navigate = useNavigate();
  const handleGoBack = () => {
    navigate(-1);
  };
  return (
    <div className="bg-dark h-[80px] flex items-center fixed w-full top-0 left-0 z-50">
      <MaContainer>
        <div className="flex items-center justify-between">
          <Link to={"/"}>
            <img src={logo} alt="Logo" className="h-full" />
          </Link>
       
            <MaButton
            onClick={handleGoBack}
              startIcon={<MdOutlineKeyboardBackspace />}
              sx={{ color: "#fff", textDecoration: "none", fontSize: "13px" }}
              variant={"link"}
              title="Go Back"
            />
         
        </div>
      </MaContainer>
    </div>
  );
};

export default Header;
